import type { FormController } from "@mittwald/flow-components/dist/components/Form";
import LoadingView from "@mittwald/flow-components/dist/components/LoadingView";
import Section from "@mittwald/flow-components/dist/components/Section";
import SelectBox from "@mittwald/flow-components/dist/components/SelectBox";
import { TranslationProvider } from "@mittwald/flow-components/dist/components/TranslationProvider";
import { WizardStep } from "@mittwald/flow-components/dist/components/Wizard/components/WizardStep";
import type { AnimationController } from "@mittwald/flow-components/dist/hooks/useAnimationController";
import Suspense from "@mittwald/flow-lib/dist/resources/Suspense";
import type { FC } from "react";
import React from "react";
import type { RegistrationInputs } from "../../../../model/signup/Signup";
import VirtualPageViewTracking from "../../../components/tracking/components/VirtualPageViewTracking";
import { LoginStepContent } from "./LoginStepContent";
import { RegistrationStepContent } from "./RegistrationStepContent";

interface Props {
  form: FormController<RegistrationInputs & { type: "registration" | "login" }>;
  rejectionAnimation: AnimationController;
  trackingId?: string;
}

export const RegistrationOrLoginStep: FC<Props> = (props) => {
  const { form, rejectionAnimation, trackingId } = props;

  const isRegistration = form.watch("type") === "registration";

  return (
    <TranslationProvider name="registrationOrLoginStepContent" type="component">
      <WizardStep
        form={form}
        id="registration"
        indicatorText={isRegistration ? "registration" : "login"}
        noReturn
      >
        <Suspense loadingView={<LoadingView _height={250} />}>
          {trackingId && (
            <VirtualPageViewTracking
              identifier={trackingId}
              name="checkout/signin"
            />
          )}
          <Section.Item>
            <SelectBox
              name="type"
              options={[
                { title: "registration", value: "registration" },
                { title: "login", value: "login" },
              ]}
            />
            {isRegistration ? (
              <RegistrationStepContent />
            ) : (
              <LoginStepContent rejectionAnimation={rejectionAnimation} />
            )}
          </Section.Item>
        </Suspense>
      </WizardStep>
    </TranslationProvider>
  );
};

export default RegistrationOrLoginStep;
